// src/pages/feedback/components/FeedbackTypeChip.tsx
//
// 유형 칩 — outlined 규격(흰 바탕 + 의미색 보더/텍스트, 도트 없음).
// 상태 칩과 같은 행에 놓이므로 "면 채움 없음"이 두 칩을 가르는 형태 채널이다.
// 치수(h22 · r6 · 1px 보더 · 11.5px/600)는 StatusChip.tsx 와 동일하게 맞춘다.

import { Box } from "@mui/material";
import { designTokens } from "../../../theme.ts";
import type { FeedbackType } from "../../../contracts/feedback/types";
import { typeVisual } from "./feedbackVisuals.ts";

const T = designTokens;

interface FeedbackTypeChipProps {
  type: FeedbackType;
  size?: "small" | "medium";
  sx?: any;
}

export default function FeedbackTypeChip({
  type,
  size = "small",
  sx,
}: FeedbackTypeChipProps) {
  const v = typeVisual(type);

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: size === "small" ? 22 : 26,
        px: 0.85,
        borderRadius: "6px",
        border: `1px solid ${v.border}`,
        bgcolor: v.bg,
        color: v.fg,
        fontFamily: T.fonts.sans,
        fontWeight: 600,
        fontSize: size === "small" ? 11.5 : 12.5,
        lineHeight: 1,
        letterSpacing: 0,
        whiteSpace: "nowrap",
        flexShrink: 0,
        ...sx,
      }}
    >
      {v.ko}
    </Box>
  );
}
